import { Participant } from 'src/services/leaderboard/get-user-points';
import React from 'react';
import { ellipseAddress } from 'src/helpers';
import { useAppTranslation } from 'src/i18n/hooks';
import { getTierImage } from '..';

interface Props {
  data?: Participant;
  isCurrentWeek?: boolean;
}

const CardItem: React.FC<Props> = ({ data, isCurrentWeek = false }) => {
  const { t } = useAppTranslation('leaderboard');

  return (
    <div className="dark:bg-gray-900/60 bg-white border hover:border-cyan-400/50 transition-all duration-300 shadow-2xl shadow-cyan-500/10  border-cyan-500/30 p-[10px] rounded-[8px] w-ful">
      <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">{t('rank')}</span>
        <span className="text-slate-700 dark:text-cyan-100">{data?.rank}</span>
      </div>
      <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">{t('trader')}</span>
        <div className="flex items-center gap-[10px]">
          {getTierImage(data?.tier) ? (
            <img
              className="w-[30px] h-[30px]"
              src={getTierImage(data?.tier)}
            />
          ) : null}
          <p className="text-slate-700 dark:text-cyan-100">
            {ellipseAddress(data?.wallet_address)}
          </p>
        </div>
      </div>
      {/* <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">{t('accountValue')}</span>
        <span className="text-slate-700 dark:text-cyan-100">
          ${format6SignificantFigures(data?.account_equity ?? 0)}
        </span>
      </div> */}

      {/* <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">{t('pnl')}</span>
        <span className="text-slate-700 dark:text-cyan-100">
          ${format6SignificantFigures(data?.pnl ?? 0)}
        </span>
      </div> */}
      {/* <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">{t('roi')}</span>
        <span className="text-slate-700 dark:text-cyan-100">
          {nFormatterV2(data?.roi?.toString() ?? '0', 2)}%
        </span>
      </div> */}
      <div className="flex justify-between">
        <span className="dark:text-gray-400 text-sm tracking-wide">
          {isCurrentWeek ? 'XP' : t('points')}
        </span>
        <span className="text-slate-700 dark:text-cyan-100">{data?.points}</span>
      </div>
    </div>
  );
};

export default CardItem;
